module.exports = __webpack_public_path__ + "img/Bundasliga.52767440.png";